import TableLineQuantityReport from './TableLineQuantityReport';

export default TableLineQuantityReport;
export { TableLineQuantityReport };
